import Vue from "vue";
import base from "./baseAuth";

export default Object.assign(
    {
        apiUrl: "/api/",

        async register({ name }) {
             this.url({
                path: "/"
            });

            return Vue.http.post("/auth"+this.apiUrl, {
                name
            });
        },

        async search({ page = 0, filter, showActive }) {            

            return Vue.http.get("/auth"+this.apiUrl, {
                params: {
                    page: page,
                    filter: filter,
                    showActive: showActive
                }
            });
        },

        async revoke({ apiId }) {            
            const url = this.url(`${apiId}`)

            return Vue.http.delete(url);
        }
    },
    base
);
